import { Expose, Type, Exclude } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnCollection, SnModel } from '@lib/common/models';

import { SnCallSign } from './call-sign';

export class SnTeam extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public color: string;

  @Expose()
  @Exclude({ toPlainOnly: true })
  public organization: string;

  @Expose()
  @Exclude({ toPlainOnly: true })
  @Type(() => SnCallSign)
  @Default(new SnCollection())
  public readonly callSigns: SnCollection<SnCallSign>;

  @Expose()
  public isPrivate: boolean;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
